import { oldApiInstance } from 'functions/request';

export const getFeatures = () => oldApiInstance.get('/configuration/web/features');
